import React, { useEffect, useState } from "react";
import { Button, Col, Empty, Row, Spin } from "antd";
import { useTranslation } from "react-i18next";
import WorkersListHeaderOptions from "./WorkListHeaderOption";
import UserDetailsCard from "./UserDetailsCard";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  getMyOrganization,
  getSubjectList,
  getSubjectListRequest,
  Subject,
  useDynamicSelector } from
"@src/redux";
import { pluralize } from "@src/helpers/constants";

const WorkersList: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { result: subjectList, loading: subjectLoading } =
  useSelector(getSubjectList);
  const { result: myOrg } = useSelector(getMyOrganization);
  // const [subject_list, set_subject_list] = useState<Subject[]>();
  const { ncdRiskFilter } = useDynamicSelector("ncd_risk_analysis");

  const handleMore = () => {
    dispatch(
      getSubjectListRequest({
        filter: {
          organizationId:
          ncdRiskFilter?.organizationId || myOrg?.rootOrganization?.id,
          fromAge: ncdRiskFilter?.fromAge,
          toAge: ncdRiskFilter?.toAge
        },
        pagination: {
          pageLimit: Number(subjectList?.pagination?.pageLimit || 7) + 10,
          pageNumber: Number(subjectList?.pagination?.pageNumber) || 1
        }
      })
    );
  };

  // useEffect(() => {
  //   if (subject_list?.items && subject_list?.items?.length > 0) {
  //     set_subject_list((prevSubjectList) => [
  //       ...(prevSubjectList || []),
  //       ...(subject_list?.items || []),
  //     ]);
  //   } else {
  //     set_subject_list([]);
  //   }
  // }, [subject_list]);
  return (
    <div className="workers-list-main-container">
      <div className="analysis-card-header-title-container">
        <div className="workers-list-card-header">
          <WorkersListHeaderOptions />
        </div>
      </div>
      <div className="workers-list-card-container">
        {subjectList &&
        subjectList?.items?.length &&
        subjectList?.items?.length > 0 ?
        subjectList?.items?.map((user, index) =>
        <a key={user?.id || index} href={`/details/${user?.id}`}>
                <UserDetailsCard
            name={user?.name || "-"}
            referenceId={user?.keyValueList?.[0]?.value || "-"}
            id={user?.id || "-"}
            profile={user?.photo} />
          
              </a>
        ) :
        ""}
      </div>
      {subjectLoading &&
      <Row justify={"center"} style={{ marginTop: "20px" }}>
          <Col>
            <Spin size="large" />
          </Col>
        </Row>}
      
      {subjectList?.items?.length === 0 && !subjectLoading &&
      <Row justify={"center"} align={"middle"}>
          <Col>
            <Empty
            description={`No ${pluralize(
              myOrg?.rootOrganization?.subjectLabel || ""
            )}`} />
          
          </Col>
        </Row>}
      
      {subjectList?.items?.length &&
      subjectList?.pagination?.totalCount &&
      subjectLoading ?
      "" :

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px"
        }}>
        
          {!subjectLoading &&
        subjectList &&
        subjectList?.items?.length &&
        subjectList?.items?.length > 0 &&
        subjectList?.pagination?.totalCount !==
        subjectList?.items?.length ?
        <Button className="load-more-button" onClick={handleMore}>
              {t("load_more")}
            </Button> :

        ""}
        
        </div>}
      
    </div>);

};

export default WorkersList;